import { defaultLocale, loadLanguageAsync } from '../setup/i18n';
import router from './index';

router.beforeEach(async (to, from, next) => {
  const langInParams = to.params.lang;
  await loadLanguageAsync(langInParams);
  next();
});
